import gql from "graphql-tag";
import {
  Sku,
  SkuRestrictions,
  SkuInventory
} from "graphql-client-product/fragments/product-sku";

export const LineItem = gql`
  fragment LineItem on ProductLineItem {
    __typename
    sku {
      ...Sku
    }
    availableOptions {
      type
      sortPriority
      optionTypeId
      adapter
      options {
        id
        type
        value
        name
        sortPriority
        status
        message
        usa_list_price_f
        usa_member_price_f
        usa_sale_price_f
        can_list_price_f
        can_member_price_f
        can_sale_price_f
        gbr_list_price_f
        gbr_member_price_f
        gbr_sale_price_f
        operationType
      }
    }
    image {
      productId
      imageUrl
    }
    customProductOptions {
      customProductInformation {
        customProductType
        cwCustomProductCode
        maxWidth
        maxLength
        minWidth
        minLength
        minDiameter
        maxDiameter
        maxControlLength
        minControlLength
        widthFractionGap
        lengthFractionGap
        diameterFractionGap
        shape
        showSizeDropDown
        type
        mountTypes {
          id
          value
          status
          message
          code
        }
        controlTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
        }
        panels {
          id
          value
          status
          message
          code
        }
        linings {
          id
          value
          status
          message
        }
        controlPositions {
          id
          value
          status
          message
        }
        rollTypes {
          id
          value
          status
          message
        }
        bracketColors {
          id
          value
          status
          message
        }
        controlsAndTilts {
          id
          value
          status
          message
        }
        tiltTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
        }
        rugTrims {
          id
          value
          status
          message
          code
        }
        finish {
          id
          value
          status
          message
        }
      }
    }
  }
  ${Sku}
`;

export const LineItemLite = gql`
  fragment LineItemLite on ProductLineItem {
    __typename
    availableOptions {
      type
      sortPriority
      optionTypeId
      adapter
      options {
        id
        type
        value
        name
        sortPriority
        status
        message
        usa_list_price_f
        usa_member_price_f
        usa_sale_price_f
        can_list_price_f
        can_member_price_f
        can_sale_price_f
        gbr_list_price_f
        gbr_member_price_f
        gbr_sale_price_f
      }
    }
    customProductOptions {
      customProductInformation {
        customProductType
        cwCustomProductCode
        maxWidth
        maxLength
        minWidth
        minLength
        minDiameter
        maxDiameter
        maxControlLength
        minControlLength
        widthFractionGap
        lengthFractionGap
        diameterFractionGap
        shape
        showSizeDropDown
        type
        mountTypes {
          id
          value
          status
          message
          code
        }
        controlTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
        }
        panels {
          id
          value
          status
          message
          code
        }
        linings {
          id
          value
          status
          message
        }
        controlPositions {
          id
          value
          status
          message
        }
        rollTypes {
          id
          value
          status
          message
        }
        bracketColors {
          id
          value
          status
          message
        }
        controlsAndTilts {
          id
          value
          status
          message
        }
        tiltTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
        }
        rugTrims {
          id
          value
          status
          message
          code
        }
        finish {
          id
          value
          status
          message
        }
      }
    }
  }
`;

export const LineItemSku = gql`
  fragment LineItemSku on ProductLineItem {
    __typename
    sku {
      ...SkuRestrictions
    }
  }
  ${SkuRestrictions}
`;

export const LineItemInventory = gql`
  fragment LineItemInventory on ProductLineItem {
    __typename
    sku {
      ...SkuInventory
    }
  }
  ${SkuInventory}
`;

export const LineItemSkuDetails = gql`
  fragment LineItemSkuDetails on ProductSku {
    ...Sku
  }
  ${Sku}
`;

export const LineItemLiteV3 = gql`
  fragment LineItemLiteV3 on ProductLineItem {
    __typename
    availableOptionsStatus {
      allOptions {
        type
        sortPriority
        adapter
        optionTypeId
        options
        __typename
      }

      swatchFamilyPrices
    }

    customProductOptions {
      customProductInformation {
        customProductType
        cwCustomProductCode
        maxWidth
        maxLength
        minWidth
        minLength
        minDiameter
        maxDiameter
        maxControlLength
        minControlLength
        widthFractionGap
        lengthFractionGap
        diameterFractionGap
        shape
        showSizeDropDown
        type
        mountTypes {
          id
          value
          status
          message
          code
          __typename
        }
        controlTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
          __typename
        }
        panels {
          id
          value
          status
          message
          code
          __typename
        }
        linings {
          id
          value
          status
          message
          __typename
        }
        controlPositions {
          id
          value
          status
          message
          __typename
        }
        rollTypes {
          id
          value
          status
          message
          __typename
        }
        bracketColors {
          id
          value
          status
          message
          __typename
        }
        controlsAndTilts {
          id
          value
          status
          message
          __typename
        }
        tiltTypes {
          id
          value
          status
          message
          continuousLoop
          motorized
          __typename
        }
        rugTrims {
          id
          value
          status
          message
          code
          __typename
        }
        finish {
          id
          value
          status
          message
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
